// Generated by CoffeeScript 2.7.0
var CurrentAttributesFactory;

export default CurrentAttributesFactory = {
  fabricate: function(...attributes) {
    var CurrentAttributesPrototype;
    return CurrentAttributesPrototype = class CurrentAttributesPrototype {
      constructor() {
        this._fetchAttributes();
      }

      resets() {
        var attr, i, len;
        for (i = 0, len = attributes.length; i < len; i++) {
          attr = attributes[i];
          this[attr] = void 0;
        }
        return this;
      }

      set(attribute, value) {
        if (_.includes(attributes, attribute)) {
          return this[attribute] = value;
        }
      }

      _fetchAttributes() {
        var attr, i, len, results, value_object;
        if (_.isFunction(this._valueObject)) {
          value_object = this._valueObject();
          if (!_.isObject(value_object)) {
            return;
          }
          results = [];
          for (i = 0, len = attributes.length; i < len; i++) {
            attr = attributes[i];
            if (_.has(value_object, attr)) {
              results.push(this.set(attr, value_object[attr]));
            } else {
              results.push(void 0);
            }
          }
          return results;
        } else {
          throw new Error('Implement @_valueObject or @_fetchAttributes');
        }
      }

    };
  }
};
